import { ReactNode } from "react"
import {
  Block,
  BlockProps,
  mergeOverrides,
  ParagraphLarge,
  Tag02,
  useStyletron,
} from "@mezo-org/mezo-clay"

import MarketBalanceHeader from "#/ui/Market/MarketBalanceHeader"

export default function MarketItemDetailsLayout({
  isSuccessPage,
  pageTitle,
  image,
  imageTagText,
  children,
  overrides,
}: {
  isSuccessPage?: boolean
  pageTitle?: string
  image: string
  imageTagText?: string
  children?: ReactNode
  overrides?: {
    Header?: BlockProps["overrides"]
    ContentContainer?: BlockProps["overrides"]
    ImageContainer?: BlockProps["overrides"]
    Content?: BlockProps["overrides"]
  }
}) {
  const [css, theme] = useStyletron()

  return (
    <>
      <MarketBalanceHeader
        pageTitle={pageTitle}
        overrides={mergeOverrides(
          {
            Block: {
              style: { visibility: isSuccessPage ? "hidden" : "visible" },
            },
          },
          overrides?.Header,
        )}
      />
      <Block
        display="flex"
        flexDirection={["column", "column", "column", "row"]}
        alignItems={
          isSuccessPage
            ? "center"
            : ["center", "center", "center", "flex-start"]
        }
        justifyContent="center"
        height="100%"
        marginRight={theme.sizing.scale600}
        marginLeft={theme.sizing.scale600}
        className={css({ gap: "50px" })}
        overrides={overrides?.ContentContainer}
      >
        <Block
          flex="1"
          className={css({ position: "relative" })}
          overrides={overrides?.ImageContainer}
        >
          <Block
            as="img"
            src={image}
            width="100%"
            className={css({ objectFit: "contain" })}
          />
          {imageTagText && (
            <Block
              className={css({
                width: "100%",
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                bottom: "25px",
              })}
            >
              <Block
                className={css({
                  display: "flex",
                  gap: "10px",
                  border: `1px dashed ${theme.colors.purple600}`,
                  borderRadius: "4px",
                  padding: "10px",
                })}
              >
                <Tag02 color={theme.colors.purple600} />
                <ParagraphLarge
                  className={css({
                    fontFamily: "RiformaMonoLLWeb-Regular",
                    fontWeight: "700!important",
                    textTransform: "uppercase",
                    color: `${theme.colors.purple600}!important`,
                  })}
                >
                  {imageTagText}
                </ParagraphLarge>
              </Block>
            </Block>
          )}
        </Block>
        <Block
          overrides={overrides?.Content}
          className={css({
            position: "relative",
            flex: "0 1 auto",
            flexBasis: "50%",
          })}
        >
          {children}
        </Block>
      </Block>
    </>
  )
}
